export default [
  {
    path: '/apps/pic/list',
    name: 'apps-pic-list',
    component: () => import('@/views/app/operacoes/pic/list/Index.vue'),
    meta: {
      pageTitle: 'Pic',
    },
  },
  {
    path: '/apps/painel-pic/list',
    name: 'apps-painel-pic-list',
    component: () => import('@/views/app/operacoes/pic/painel/Index.vue'),
    meta: {
      pageTitle: 'Painel Pic',
    },
  },
];
